import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom';
import { Row, Col } from 'antd';
import "../utils/style.css"
import { Navigate } from 'react-router-dom';
import globalRouter from "globalRouter.ts";


function SecurityLayout({ profileData, initialRefetch }) {
    const auth = localStorage.getItem("token") ? true : false;
    const isSecurity = (localStorage.getItem("role") === 'SECURITY');
  
    useEffect(() => {
        initialRefetch();
    }, []);
    
    const [logout, setLogout] = useState(false);
    const timeout = 3600000; 

    useEffect(() => {
        let timer;

        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(() => setLogout(true), timeout);
        };

        const events = [
            'load',
            'mousemove',
            'mousedown',
            'click',
            'scroll',
            'keypress'
        ];

        const resetEvents = () => {
            events.forEach(event => {
                window.addEventListener(event, resetTimer);
            });
        };

        resetTimer();
        resetEvents();

        return () => {
            clearTimeout(timer);
            events.forEach(event => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [timeout]);

    useEffect(() => {
        if (logout) {
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            globalRouter.navigate("/login", { state: { message: "Session Time Out! Please ReLogin." } });
        }
       
    }, [logout]);

    if (auth && !isSecurity) {
        return <Navigate to="/dashboard" replace={true} />
    }

    return auth ?
        <div className="thales-app-view security-layout-wrapper">
            <Row>
                <Col lg={24} xl={24} md={24} xs={24} className="thales-body">
                    <Outlet />
                </Col>
            </Row>
        </div> : <Navigate to="/login" replace={true} />
}
export default SecurityLayout